import { Injectable } from '@angular/core';
import { AppService } from '../app.service'
import { StorageService } from './storage.service'
import { saveAs } from 'file-saver';
import { HttpClient } from '@angular/common/http';

@Injectable()
export class LocalStorageService implements StorageService {

  constructor(protected httpClient: HttpClient) { }

  /** load the configuration in the file to the appService
   * @param inputValue - uploaded file
   * @param appService - appService to send configuration to
   */
  loadConfig(inputValue: any, appService: AppService): void {
    var file: File = inputValue.files[0];
    var myReader: FileReader = new FileReader();

    myReader.readAsText(file);
    myReader.onloadend = function (e) {
      appService.configuration = JSON.parse(myReader.result.toString());
      appService.onLoadedConfig();
    }

  }

  /** load the state in the file to the appService
   * @param inputValue - uploaded state
   * @param appService - appService to send state to
   */
  loadState(inputValue: any, appService: AppService): void {
    var file: File = inputValue.files[0];
    var myReader: FileReader = new FileReader();

    myReader.readAsText(file);
    myReader.onloadend = function (e) {
      let state = JSON.parse(myReader.result.toString());
      appService.onLoadedState(state);
    }
  }

  /** store the given state locally
   * @param state - state to store
   * @param appService - appService the state comes from
   */
  storeState(state: any, appService: AppService): boolean {
    let blob = new Blob([JSON.stringify(state, null, 2)], {
      type: "application/json"
    });
    saveAs(blob, "state.json");
    return false;
  }

  /** stores the configuration with predefined prefix
   * @param configuration - configuration to store
   * @param prefix - prefix for the proprsed file name
   * @param appService - appService configuration comes from
   */
  storeConfig(configuration: any, prefix: String, appService: AppService): boolean {
    let blob = new Blob([JSON.stringify(configuration, null, 2)], {
      type: "application/json"
    });
    saveAs(blob, prefix.concat("configuration.json"));
    return false;
  }

}
